<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import PanelPerfilDesplegable from './dropsDowns/perfil/PanelPerfilDesplegable.vue'
import { iniciarSesion, registro } from '@/utils/usuarioRedirections'
import { verCategoriaLote } from '@/utils/subastaRedirections'

const props = defineProps({
  categoriasLotes: Object,
  usuarioStore: Object,
})

const baseUrl = process.env.VUE_APP_SISTEMA_SUBASTAS_ACTUAL_URL

const route = useRoute()
const isHome = computed(() => route.path === '/' || route.name === 'home')
const isComoParticipar = computed(() => route.path === '/como-participar' || route.name === 'como_participar')

const isOpenTip = ref(false)
const tipificadosRef = ref(null)

const isOpenPanel = ref(false)
const triggerPerfilDesktop = ref(null)

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})
onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})

const userInitials = computed(() => {
  const name = props.usuarioStore?.user?.name
  if (!name) return 'US'
  const parts = name.trim().split(' ').filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  if (parts.length === 1 && parts[0].length >= 2) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + 'X').toUpperCase()
})

const userPhoto = computed(() => {
  const photo = props.usuarioStore?.user?.foto_url ?? props.usuarioStore?.user?.perfil?.foto_url
  const value = typeof photo === 'string' ? photo.trim() : ''
  return value || ''
})

function toggleCollapsePanel() {
  isOpenPanel.value = !isOpenPanel.value
  if (isOpenPanel.value) isOpenTip.value = false
}

function toggleTipificados() {
  isOpenTip.value = !isOpenTip.value
  if (isOpenTip.value) isOpenPanel.value = false
}

function handleClickOutside(e) {
  const tip = tipificadosRef.value
  const trig = triggerPerfilDesktop.value
  const perfilPanel = document.querySelector('.panel-perfil-desplegable')

  const insideTip = tip && tip.contains(e.target)
  const insideTrig = trig && trig.contains(e.target)
  const insidePerfil = perfilPanel && perfilPanel.contains(e.target)

  if (!insideTip) isOpenTip.value = false
  if (!insideTrig && !insidePerfil) isOpenPanel.value = false
}
</script>


<template>
  
  <header class="navbar-expand-lg shadow-none navbar-light bg-white navbar-fixed" style="height: 101px;">
    <div class="barra verde bg-primary" style="height: 6px; width: 100%;"></div>
    <div class="container p-0 pe-0 ps-0 mb-1 p-1">
      <!-- top line -->
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="text-soft-grey-74 nav-link mb-0 pb-0 pt-0 pe-2">
          <i class="fa-solid fa-phone me-1"></i><span class="text-soft-grey-74"> (5411) 3984-7400 </span>
        </div>
        <div class="d-flex">
          <a :href="`${baseUrl}/medios`" class="text-soft-grey-74 nav-link mb-0 pb-0 pt-0 pe-2">Medios</a>
          <a :href="`${baseUrl}/blog`" class="text-decoration-none text-soft-grey-74 nav-link mb-0 pb-0 pt-0 pe-2">Novedades</a>
          <a :href="`${baseUrl}/institucional`" class="text-decoration-none text-soft-grey-74 nav-link mb-0 pb-0 pt-0 pe-2">Quiénes Somos</a>
          <a :href="`${baseUrl}/subastas/preguntas-frecuentes`" class="text-decoration-none text-soft-grey-74 nav-link mb-0 pb-0 pt-0 pe-2">Preguntas
            frecuentes</a>
          <a :href="`${baseUrl}/terminos`" class="text-decoration-none text-soft-grey-74 nav-link mb-0 pb-0 pt-0 pe-2">Términos y Condiciones</a>
        </div>
      </div>

      <div class="separator bg-soft-grey-74 opacity-2"></div>

      <div class="d-flex justify-content-between align-items-center p-2 mt-2 pe-0 ps-0">
        <a href="/">
          <img src="@/assets/logo_adrian_mercado.svg" alt="Adrián Mercado" class="img-fluid"
            style="max-height: 40px;">
        </a>

        <nav class="nav d-none d-lg-flex pe-2 ps-2">
          <a class="nav-link fw-bold" :href="`${baseUrl}/`">Subastas en vivo</a>
          <a class="nav-link fw-bold pe-2 ps-1" href="/"
            :class="{ 'text-primary': isHome, 'active': isHome }">Subastas cronometradas</a>
          <a class="nav-link fw-bold"  href="/usuario">Mi cuenta</a>

          <!-- Categorías -->
          <div class="nav-item position-relative" ref="tipificadosRef">
            <a href="javascript:;" class="nav-link fw-bold d-flex align-items-center tipificados-toggle pe-2 ps-2"
              @click.prevent="toggleTipificados">
              Categorías
              <i class="fa ms-1 fs-6" :class="isOpenTip ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </a>
            <div class="dropdown-menu show shadow border-0 py-2 rounded-1 mt-1" v-if="isOpenTip"
              style="min-width:260px; max-height:50vh; overflow:auto; top:100%; left:0;">
              <a v-for="t in categoriasLotes" :key="t.id" @click="verCategoriaLote(t.id)"
                class="dropdown-item py-2 ps-3 fw-bold cursor-pointer">
                {{ t.nombre }}
              </a>
              <div v-if="!categoriasLotes?.length" class="px-3 py-2 text-muted small">(Sin categorías aún)</div>
            </div>
          </div>

          <!-- <a class="nav-link fw-bold" :href="`${baseUrl}/subastas-vender`">Vender</a> -->
          <a class="nav-link fw-bold ps-2" href="/como-participar"
            :class="{ 'text-primary': isComoParticipar, 'active': isComoParticipar }">Cómo Participar</a>
        </nav>

        <div class="d-flex align-items-center">
          <button type="button" v-if="!usuarioStore?.isAuthenticated" @click="iniciarSesion()"
            class="btn btn-outline-primary">Ingresar</button>

          <div v-if="usuarioStore?.isAuthenticated" ref="triggerPerfilDesktop" class="d-flex align-items-center"
            @click.stop="toggleCollapsePanel" style="cursor: pointer;">
            <div
              class="rounded-circle bg-light text-primary fw-bold d-flex align-items-center justify-content-center me-2 border-primary"
              style="width: 44px; height: 44px;">
              <img
                v-if="userPhoto"
                :src="userPhoto"
                alt="Perfil"
                class="rounded-circle w-100 h-100"
                style="object-fit: cover;"
              />
              <span v-else>{{ userInitials }}</span>
            </div>
            <span class="fw-bold me-2 text-capitalize fs-14 text-primary">
              Hola {{ usuarioStore?.user?.name?.split(' ')[0] }}
            </span>
            <i :class="isOpenPanel ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
              class="fs-7 mt-0 text-primary"></i>
          </div>

          <div class="d-flex align-items-center" style="cursor: pointer;" v-if="!usuarioStore?.isAuthenticated">
            <button @click="registro()" class="ms-2 btn btn-primary">Registrarse</button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end" @click.stop>
        <PanelPerfilDesplegable :isOpenPanel="isOpenPanel" />
      </div>
    </div>
  </header>
</template>

<style scoped>
.separator {
  width: 100%;
  height: 1px;
  margin: 0.3rem 0;
}

.nav-link {
  font-size: 14px;
}

.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1050;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
</style>